module.exports = __webpack_public_path__ + "static/media/glowing-container.8e569ab0.png";